// Module
var code = "<span class=\"text-sm\"> Net interconnector flow is positive for imports and negative for exports </span>\n";
// Exports
export default code;